import React from 'react';

import useAdditionalContactO15OtherAddEditContact from './UseAdditionalContactO15OtherAddEditContact';
import AdditionalContactAddEditForm from '../AdditionalContactAddEditForm';
import Views from '../../../Views';
import ViewTemplate from '../../../components/viewTemplate/ViewTemplate';
import AddressBook from '../../../components/AddressBook/AddressBook';
import NavLinks from '../../../NavLinks';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const AdditionalContactO15OtherAddEditContact = () => {
  const {
    formState,
    errorState,
    onFormValueChanged,
    onValueTextPairChanged,
    onCountryChanged,
    setFormData,
    onNextButtonClicked,
    validateState,
    onBackButtonClicked,
    isCountryUSA,
    isCountryMexico,
    isCountryCanada
  } = useAdditionalContactO15OtherAddEditContact();

  return (
    <ViewTemplate
      viewName={Views.ADDITIONAL_CONTACTS_O15_OTHER_ADD_EDIT_CONTACT}
      onBackButtonClicked={onBackButtonClicked}
      onNextButtonClicked={onNextButtonClicked}>
      {validateState.isValidating === true && (
        <PopUpModal
          displayPopUp={true}
          maxWidth={250}
          title="Validating..."
          widthPct={50} />
      )}
      <AddressBook navlink={NavLinks.ADDITIONAL_CONTACTS_O15_OTHER_ADD_EDIT_CONTACT} />
      <AdditionalContactAddEditForm
        formState={formState}
        errorState={errorState}
        onFormValueChanged={onFormValueChanged}
        onValueTextPairChanged={onValueTextPairChanged}
        setFormData={setFormData}
        onCountryChanged={onCountryChanged}
        isCountryUSA={isCountryUSA}
        isCountryMexico={isCountryMexico}
        isCountryCanada={isCountryCanada} />
    </ViewTemplate>
  );
};

export default AdditionalContactO15OtherAddEditContact;